import { useReducer } from 'react';
import reducer, { defaultState } from './reducer';

export default function useCampaignCreationState() {
  return useReducer(reducer, defaultState);
}
